import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/ItemReport/WarehouseReportItemAction'
import {can} from "framework/utils/AccessRights"
import TranslationAsatorindo from "app/modules/Accounting/TranslationAsatorindo"
import Cookies from 'js-cookie'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseReportItemActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/ItemReport/WarehouseReportItem")
		this.lang = Cookies.get("lang")
	}

	render() {
		let label = "WarehouseReportItem"
		if (can("menu.asatorindo")){
			label = TranslationAsatorindo[this.lang][label]
		}
		return (
			<Activity 
				name={label}
				RenderedComponent={this.RenderedComponent}
				context="WarehouseReportItem"
				action="WarehouseReportItem"
				formActions={FormAction}			
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseReportItemActivity)
